import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpResponse,
    HttpErrorResponse
} from '@angular/common/http';

import {Inject, Injectable} from '@angular/core';
import {OKTA_AUTH} from '@okta/okta-angular';
import {OktaAuth} from '@okta/okta-auth-js';
import {environment} from '@env';

import {catchError, tap} from 'rxjs/operators';
import {Observable, throwError} from 'rxjs';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(@Inject(OKTA_AUTH) private oktaAuth: OktaAuth) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return this.handleAccess(request, next);
    }

    private handleAccess(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Only add an access token to allowed origins
        const allowedOrigins = [environment.apiUrl, environment.lambdaGatewayUrl, environment.menuGatewayUrl];
        if (allowedOrigins.some(url => request.urlWithParams.includes(url))) {
            // accessToken doesn't work with AWS API Gateway, idToken does, so I replaced it.
            // Find a different solution if this causes issues with other endpoints.
            const accessToken = JSON.parse(sessionStorage.getItem('okta-token-storage'))?.idToken?.idToken || '';
            request = request.clone({
                setHeaders: {
                    Authorization: 'Bearer ' + accessToken
                }
            });
        }
        return next.handle(request).pipe(
            tap(event => {
                if (event instanceof HttpResponse && event.status === 200) {
                    // If you want to take an action on a success response, do it here.
                }
            }),
            catchError((error: HttpErrorResponse) => {
                if (error.status === 401) {
                    // Set URI at time of failure and redirect to Okta to Re-auth
                    this.oktaAuth.setOriginalUri(window.location.href);
                    this.oktaAuth.signInWithRedirect().then();
                }
                return throwError(error);
            })
        );
    }
}
